import { Layout } from 'antd';
import MenuList from './MenuList';
const { Header } = Layout;

const NavBar = ({
  k,
  active,
  setactive,
  top
}) => {
  return (
    <Layout>
      <Header
        id='header'
        style={{
          position: 'fixed',
          zIndex: 1,
          width: '100%',
          height: "85px",
          top: top > 300 ? "0" : "-150px",
          transition: "all .7s  "
        }}>
        <MenuList
          k={k}
          active={active}
          setactive={setactive}
        />
      </Header>
    </ Layout>
  )
}

export default NavBar;